import React, { useEffect } from "react";
import DeliverableFormData from "./components/DeliverableFormData";
import DeliverableTableData from "./components/DeliverableTableData";
import { useDispatch, useSelector } from "react-redux";
import { fetchStaffs } from "../../../store/features/user/userSlice";
import { fetchDeliverables } from "../../../store/features/deliverable/deliverableSlice";

const Deliverables = ({
  setDeliverablesInfo,
  deliverablesInfo,
  setShowDeliverableModal,
  showDeliverableModal,
  setTabKey,
  setWpInfo,
  wpInfo,
}) => {
  const dispatch = useDispatch();
  const { role } = useSelector((state) => state.auth);
  useEffect(() => {
    dispatch(fetchStaffs());
    dispatch(fetchDeliverables());
  }, [dispatch]);

  return (
    <div>
      {role !== "staff" && role !== "auditor" && (
        <DeliverableFormData
          setDeliverablesInfo={setDeliverablesInfo}
          deliverablesInfo={deliverablesInfo}
          setShowDeliverableModal={setShowDeliverableModal}
          showDeliverableModal={showDeliverableModal}
        />
      )}

      <DeliverableTableData
        setDeliverablesInfo={setDeliverablesInfo}
        setShowDeliverableModal={setShowDeliverableModal}
        setTabKey={setTabKey}
        setWpInfo={setWpInfo}
        wpInfo={wpInfo}
      />
    </div>
  );
};

export default Deliverables;
